<script lang="ts">
    import { onMount } from 'svelte';
    import { params, push, querystring } from 'svelte-spa-router';
    import { get } from 'svelte/store';
    import SearchResultList from './global/search-result-list.svelte';
    import { StringUtils } from '$lib/stringUtils';

    let currentPage: number = 1
	let currentSearch: string = ''

	const defaultPage = 1;

	onMount(() => extractQueryString($querystring));

	$: extractQueryString($querystring);

	function extractQueryString(qs?: string) {

		var searchParam = new URLSearchParams(qs);
		if( searchParam ) {
			currentPage = StringUtils.getNumberOrDefault(searchParam.get('page'),  defaultPage);
			currentSearch = searchParam.get('q') ?? '';
            var x = 1;
		}
		else {
			currentPage = defaultPage;
			currentSearch = '';
		}
	}

</script>

{#if !StringUtils.isNullOrEmpty(currentSearch)}
    <SearchResultList currentPage={currentPage} search={currentSearch} />
{/if}
